export function Footer() {
  return (
    <footer className="foot">
      <span>Adi Kishore</span>
      <span className="foot__mid">Built in Sydney</span>
      <span>© {new Date().getFullYear()}</span>
    </footer>
  );
}
